import React, { ReactElement } from 'react';

import { PpBreadcrumbs } from '../PpBreadcrumbs';
import ResultCount from '../resultList/ResultCount';
import SortDropdown from '../filters/SortDropdown';

export const DesktopTopBar: React.FC = (): ReactElement => (
    <div className="panel grid" data-testid="topBar">
        <div className="grid__unit u-r-size1of3">
            <PpBreadcrumbs />
        </div>
        <div className="grid__unit u-r-size2of3">
            <div className="u-r-size1of3 u-ma16 u-float-left">
                <ResultCount />
            </div>
            <div className="u-r-size1of2 u-float-right">
                <SortDropdown />
            </div>
        </div>
    </div>
);
